import { useSuspenseQuery } from '@apollo/client/react';

import { AppProtectionAssuranceSummaryDocument } from 'src/graphql/actions/apps/appProtectionAssuranceSummary.query';
import { getOwnedVariable, type IOwnershipFilter } from 'src/containers/Home/model';
import { withSuspense } from 'src/hoc';

import { ASSURANCE_LEVELS } from '../model';

import AssuranceBars from './AssuranceBars';
import AssuranceLevelRow from './AssuranceLevelRow';
import AssuranceSummarySkeleton from './AssuranceSummarySkeleton';
import AssuranceTotals from './AssuranceTotals';

type Props = {
  ownershipFilter: IOwnershipFilter;
};

const AssuranceSummary = ({ ownershipFilter }: Props) => {
  const {
    data: { appProtectionAssuranceSummary: summary },
  } = useSuspenseQuery(AppProtectionAssuranceSummaryDocument, {
    variables: getOwnedVariable(ownershipFilter),
    fetchPolicy: 'cache-and-network',
  });

  return (
    <div className="space-y-6">
      <AssuranceTotals summary={summary} />
      <AssuranceBars summary={summary} />
      <ul aria-label="Verification levels" className="space-y-1">
        {ASSURANCE_LEVELS.map((level) => (
          <AssuranceLevelRow key={level.key} level={level} />
        ))}
      </ul>
    </div>
  );
};

export default withSuspense(AssuranceSummary, AssuranceSummarySkeleton);
